import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import AccountCircle from "@mui/icons-material/AccountCircle";
import HttpsIcon from "@mui/icons-material/Https";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../store/Slice/authSlice";
import { useNavigate } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import AlertStatus from "../Components/AlertStatus";
import { URL_IMAGE, URL_LOGIN_LINE } from "../Config";
import LoginTwoToneIcon from "@mui/icons-material/LoginTwoTone";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector(({ auth }) => auth);
  const alert = useSelector(({ alert }) => alert);
  const setting = useSelector(({ setting }) => setting);

  const [forgotPassword, setForgotPassword] = useState(false);
  const handleLogin = async (formValue) => {
    const { idcard, password } = formValue;
    const data = await dispatch(login({ idcard, password }));
    if (data.payload?.status === true) {
      navigate("/lab");
      document.body.classList.remove("login-background");
    }
  };
  useEffect(() => {
    document.body.classList.add("login-background");
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={setting.detail_load}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mt: 0 }}
      >
        <Grid item xs={12} md={12}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{ m: 2, ml: { md: 0, xs: 2 } }}
          >
            <Paper
              elevation={0}
              sx={{ mt: 10, borderRadius: 5, maxWidth: 600 }}
            >
              <Box sx={{ padding: "24px", mt: 5 }}>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Grid item xs={12} md={12}>
                    <Stack
                      direction="column"
                      justifyContent="center"
                      alignItems="center"
                    >
                      {/* <Avatar
                        variant="rounded"
                        src={URL_IMAGE + setting.detail_logo}
                        sx={{
                          width: 100,
                          height: 100,
                        }}
                      /> */}
                      <img
                        src={URL_IMAGE + setting.detail_logo}
                        style={{ width: 150 }}
                        loading="lazy"
                      />
                      <Typography variant="h6" component="h2" mt={2}>
                        {setting.detail_name}
                      </Typography>
                      {/* <Typography variant="body2" component="span">
                      Enter your credentials to continue
                    </Typography> */}
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={9}>
                    <Formik
                      initialValues={{
                        idcard: "",
                        password: "",
                      }}
                      onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        handleLogin(values);
                        // setTimeout(() => {
                        //   alert(JSON.stringify(values, null, 2));

                        // }, 400);
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        /* and other goodies */
                      }) => (
                        <Box>
                          {/* <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              mb: 2,
                            }}
                          >
                            <img
                              src={process.env.PUBLIC_URL + "/Logo.png"}
                              alt="logo"
                              width={80}
                            />
                          </Box> */}
                          {/* <Typography
                          variant="h6"
                          sx={{
                            display: "flex",
                            justifyContent: "start",
                            alignContent: "center",
                          }}
                        >
                          Welcome to {APP}
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            display: "flex",
                            justifyContent: "start",
                            alignContent: "center",
                            color: "rgba(58, 53, 65, 0.6)",
                          }}
                        >
                          Sign in to Continue
                        </Typography> */}
                          <form onSubmit={handleSubmit}>
                            <Stack direction="column" spacing={2} mt={4}>
                              {alert.open && (
                                <AlertStatus
                                  severity={alert.status}
                                  msg={alert.msg}
                                />
                              )}
                              <TextField
                                id="idcard"
                                label="เลขบัตรประชาชน"
                                type="text"
                                name="idcard"
                                value={values.idcard}
                                onChange={handleChange}
                                variant="outlined"
                                // fullWidth
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <AccountCircle />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              <TextField
                                id="password"
                                label="รหัสผ่าน"
                                name="password"
                                value={values.password}
                                onChange={handleChange}
                                variant="outlined"
                                type="password"
                                // fullWidth
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <HttpsIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              {forgotPassword && (
                                <AlertStatus
                                  severity="error"
                                  msg="กรุณาระบุ Username"
                                />
                              )}
                              {/* <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                       <LoadingButton
                        loading={staff.loadingFind}
                        onClick={() => {
                          if (!values.username) {
                            setForgotPassword(true);
                          } else {
                            dispatch(staff_find(values.username))
                              .unwrap()
                              .then((data) => {
                                if (data.status === true) {
                                  setForgotPassword(false);
                                  setForgotPasswordDialog(true);
                                }
                              });
                          }
                        }}
                        sx={{ textTransform: "capitalize" }}
                      >
                        Forgot Password?
                      </LoadingButton> 
                       <ForgotPassword
                        open={forgotPasswordDialog}
                        handleClose={() => {
                          setForgotPasswordDialog(false);
                        }}
                      /> 
                    </Box> */}
                            </Stack>
                            <Stack
                              direction="row"
                              justifyContent="center"
                              alignItems="center"
                              spacing={2}
                              mt={5}
                            >
                              <LoadingButton
                                fullWidth
                                loading={auth.loading}
                                variant="contained"
                                type="submit"
                                disabled={isSubmitting}
                                startIcon={<LoginTwoToneIcon />}
                              >
                                เข้าสู่ระบบ
                              </LoadingButton>
                            </Stack>
                          </form>
                        </Box>
                      )}
                    </Formik>
                  </Grid>
                  {setting.status_register === "Y" && (
                    <Grid item xs={12} md={9}>
                      <Divider sx={{ mt: 2 }}>or</Divider>
                      <Button
                        fullWidth
                        variant="outlined"
                        color="success"
                        sx={{ textTransform: "none", mb: 2, mt: 2 }}
                        startIcon={
                          <Avatar
                            variant="rounded"
                            src={process.env.PUBLIC_URL + "/line.png"}
                            sx={{
                              width: 20,
                              height: 20,
                            }}
                          />
                        }
                        onClick={() => {
                          window.location.href = URL_LOGIN_LINE + "login/line";
                        }}
                      >
                        Sing in with LINE
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Paper>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}
